const DEFAULT_FALLBACK_MESSAGE =
  "Si è verificato un errore. Riprova più tardi.";

const DEFAULT_ERROR_MESSAGES = {
  email_already_used: "L'email inserita è già in uso.",
  invalid_devEUI: "Dev EUI già esistente",
  invalid_credentials: "Credenziali non valide.",
  unauthorized: "Non sei autorizzato ad eseguire questa operazione.",
  validation_error: "Errore di validazione. Verifica i dati inseriti.",
  assigned_field_reference:
    "Il terreno selezionato non è valido o non è associato all'utente.",
  error_generic_400: "Verifica i dati inseriti e riprova.",
};

const isGenericAxiosMessage = (message) =>
  /^request failed with status code/i.test(message);

const isAssignedFieldReferenceMessage = (message = "") => {
  const normalizedMessage = message.toLowerCase();

  return (
    normalizedMessage.includes("assigned_field_id") &&
    normalizedMessage.includes("foreign key")
  );
};

export const getErrorMessage = (error, options = {}) => {
  const {
    fallback = DEFAULT_FALLBACK_MESSAGE,
    messages = {},
    showBackendMessage = true,
  } = options;
  const errorMessages = { ...DEFAULT_ERROR_MESSAGES, ...messages };

  if (!error) return null;

  if (typeof error === "string") {
    if (errorMessages[error]) return errorMessages[error];
    if (isGenericAxiosMessage(error)) return fallback;
    return error;
  }

  const localizedError =
    error?.error?.localized_error || error?.localized_error;
  const message = error?.error?.message || error?.message;

  if (localizedError && errorMessages[localizedError]) {
    return errorMessages[localizedError];
  }

  if (message && isAssignedFieldReferenceMessage(message)) {
    return errorMessages.assigned_field_reference;
  }

  if (message && errorMessages[message]) {
    return errorMessages[message];
  }

  if (message && !isGenericAxiosMessage(message) && showBackendMessage) {
    return message;
  }

  return fallback;
};

export const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
